/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Watch_Next_LabelInputs */

const en_features_watch_next_label = /** @type {(inputs: Features_Watch_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const pl_features_watch_next_label = /** @type {(inputs: Features_Watch_Next_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Features_Watch_Next_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_watch_next_label = /** @type {((inputs?: Features_Watch_Next_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Watch_Next_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_watch_next_label(inputs)
	return en_features_watch_next_label(inputs)
});